import { createContext } from "react";

const barbarContext = createContext();

export default barbarContext;